/** Called when InvokeAPI refreshes the access token (401 + session refresh). */
let onAccessTokenRefreshed = null;

export function registerAccessTokenRefreshHandler(fn) {
  onAccessTokenRefreshed = fn;
}

export function notifyAccessTokenRefreshed(payload) {
  if (typeof onAccessTokenRefreshed === "function") {
    onAccessTokenRefreshed(payload);
  }
}
